export const Button1 = ({ buttonName, className, onClick, style, disabled, ...props }) => {
  return (
    <>
      <button
        className={` btn  rounded-5 px-3 ${className}`}
        onClick={onClick}
        style={style}
        disabled={disabled}
        {...props}
      >
        {buttonName}
      </button>
    </>
  );
};

export const Button2 = ({
  buttonName,
  className,
  icon,
  divClassName,
  style,

  onClick,
  before = true,
  disabled,
  ...props
}) => {
  const after = !before;

  return (
    <>
      <button
        className={`rounded-5 btn  ${className}`}
        style={style}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        <div className={`d-flex align-items-center  ${divClassName}`}>
          {before && icon}
          <span>{buttonName}</span>
          {after && icon}
        </div>
      </button>
    </>
  );
};
